import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { changeLang } from '../../../../Redux/Action/LoginAction'
import { SendingEmail } from '../../../../Redux/Action/ForgetAction'
import LoadingBar from 'react-redux-loading-bar'
import String from '../../../../Assets/locals'
import SendEmail from '../sendEmail/sendEmail'
import ConfirmationCode from '../ConfirmationCode/ConfirmationCode'
import ResetPassword from '../ResetPassword/resetPassword'

class Forget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            closeAll: false,
            RedirectTo: false,
            code: null,
            codeErr: false,
            userCode: null
        };


    }
    componentWillMount() {
        let lang = localStorage.getItem("JazanLanguage") ? JSON.parse(localStorage.getItem("JazanLanguage")) : null
        if (lang) {
            this.props.changeLang(lang)
        } else {
            this.props.changeLang(JSON.parse(localStorage.getItem("ar")))
        }
    }


    onSubmit = (values) => {
        let data = {
            email: localStorage.getItem("JazanType"),
            code: values.code,
            type: localStorage.getItem("JazanType")
        }
        this.props.SendingEmail(data, this.props.lang)
    }
    render() {
        const { handleSubmit, submitting } = this.props
        String.setLanguage(this.props.lang)
        let lang = this.props.lang


        return (
            <div>
                <div className="loading-bar" >
                    <LoadingBar style={{ height: '5px', zIndex: 1000, backgroundColor: "#006B30" }} />
                </div>

                <div className="bg-login">
                    <div className="container">
                        {this.props.page === 'email' && <SendEmail />}
                        {this.props.page === 'confirmationCode' && <ConfirmationCode />}
                        {this.props.page === 'resetPassword' && <ResetPassword />}
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        lang: state.login.language,
        token: state.login.token,
        page: state.forget.page,
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        SendingEmail,
        changeLang
        // visit
    }
    , dispatch
)
export default reduxForm({
    form: 'fieldLevelValidation',

})(connect(mapStateToProps, mapDispatchToProps)(Forget));
